import * as React from 'react';
import { ImpureIconContainer } from './utils/IconContainer';
var GoogleCalendar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.21 3.79H3.79v8.42h8.42V3.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.21 16 16 12.21h-3.79V16Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.79h-3.79v8.42H16V3.79Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.21 12.21H3.79V16h8.42v-3.79Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.21v2.527C0 15.435.565 16 1.263 16H3.79v-3.79H0Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.79V1.262C16 .565 15.435 0 14.737 0h-2.526v3.79H16Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.21 0H1.264C.565 0 0 .565 0 1.263v10.948h3.79V3.788h8.42V0Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.517 10.322c-.315-.212-.533-.523-.652-.934l.73-.3c.067.252.183.448.348.587a.895.895 0 0 0 .598.207.922.922 0 0 0 .616-.218.696.696 0 0 0 .258-.555c0-.229-.09-.416-.272-.562a1.053 1.053 0 0 0-.68-.218h-.422v-.723h.379c.234 0 .43-.063.59-.19a.625.625 0 0 0 .24-.518.573.573 0 0 0-.214-.469.832.832 0 0 0-.544-.175c-.215 0-.386.057-.512.171-.126.115-.221.26-.276.422l-.723-.3c.096-.272.272-.512.53-.72.257-.207.587-.311.987-.311.296 0 .562.057.798.171.236.115.42.274.554.476.134.203.2.43.2.683 0 .258-.062.476-.186.655a1.284 1.284 0 0 1-.458.412v.043c.234.096.437.254.588.458.152.205.23.45.23.737 0 .286-.074.542-.219.766a1.509 1.509 0 0 1-.6.53 1.895 1.895 0 0 1-.863.193c-.37.001-.71-.105-1.025-.318Zm4.487-3.625-.802.58-.401-.609 1.439-1.037h.551v4.895h-.787v-3.83Z",
    fill: "#4285F4"
  })));
});
export default GoogleCalendar;